import endOf from './endOf'

export default endOf
